import { render, staticRenderFns } from "./VideoAdminPage.vue?vue&type=template&id=98ba6b52&"
import script from "./VideoAdminPage.vue?vue&type=script&lang=js&"
export * from "./VideoAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports